import BaseRepository from "@/services/resources/repository";
import queryByKeys from "@/services/resources/mixins/query-by-keys";
import translatable from "@/services/resources/mixins/translatable-record";
import Context from "@/services/context";

class Repository extends BaseRepository {
    static #fetchPromises = {};

    static make(model, schema) {
        return new Repository(model, schema).$mix(queryByKeys).$mix(translatable);
    }

    getLabels(){
        if (Repository.#fetchPromises[Context.getLanguage()]) {
            return Repository.#fetchPromises[Context.getLanguage()];
        }

        Repository.#fetchPromises[Context.getLanguage()] = this.transformer.many(
            this.try(
                this.baseQuery()
                    .include('translated')
                    .get()
            )
        );

        return Repository.#fetchPromises[Context.getLanguage()];
    }
}

export default Repository;
